module.exports = __webpack_public_path__ + "img/project9_9.png.67de26a4.webp";